<template>
  <Page class="detailView">
    <div class="detailView-with-actions mt-5">
      <a-form-model class="flex-form form-label-6" :form="form" :colon="false" labelAlign="left">
        <div class="pageContent-title">旅行社信息</div>
        <div class="form-base-width">
          <a-form-model-item label="企业名称" required>
            <a-input v-model="form.companyName"></a-input>
          </a-form-model-item>
          <a-form-model-item label="联系人">
            <a-input v-model="form.userName"></a-input>
          </a-form-model-item>
          <a-form-model-item label="联系电话" required>
            <a-input v-model="form.phone"></a-input>
          </a-form-model-item>
          <a-form-model-item label="申请日期" required>
            <a-input v-model="form.createTime"></a-input>
          </a-form-model-item>
        </div>
        <div class="pageContent-title">企业信息</div>
        <div class="form-base-width">
          <a-form-model-item v-if="form.companyType == 'COMPANY'" label="营业执照" required>
            <div style="display: flex; gap: 20px;align-items: flex-end">
              <div style="width: 120px;heihgt: 80px">
                <img :src="form.businessLicense" style="width: 100%;height: 100%" alt="" />
              </div>
              <a-button
                v-if="!form.kuaiqianAuditStatus"
                style="margin-left: 20px; margin-top: 116px"
                :loading="businessLoading"
                @click="ocrIdentify(form.businessLicense, 'business')"
              >
                ocr识别营业执照
              </a-button>
            </div>
          </a-form-model-item>
          <a-form-model-item v-if="form.companyType == 'COMPANY'" label="营业执照编号" required>
            <a-input v-model="form.businessRegno" placeholder="请输入营业执照编号"></a-input>
          </a-form-model-item>
          <a-form-model-item label="身份证">
            <div style="display: flex; gap: 20px">
              <div style="width: 120px;heihgt: 80px">
                <img :src="form.idCard" style="width: 100%;height: 100%" alt="" />
              </div>
              <div style="width: 120px;heihgt: 80px">
                <img :src="form.idCardBack" style="width: 100%;height: 100%" alt="" />
              </div>
            </div>
          </a-form-model-item>
        </div>
      </a-form-model>
    </div>
    <div class="detailView-actions" v-if="form.companyStatus == 1">
      <a-button class="app-btn" type="default" @click="doSave(false)">审核失败</a-button>
      <a-button class="app-btn" type="primary" @click="doSave(true)">审核成功</a-button>
    </div>
  </Page>
</template>
<script>
import Page from '@/components/Page'
import { toolMixin, queryViewMixin } from '@/utils/mixin'
export default {
  components: {
    Page,
  },
  mixins: [toolMixin, queryViewMixin],
  data() {
    return {
      form: [],
      businessLoading: false,
    }
  },
  computed: {
    typesMap() {
      return {
        status: [
          {
            value: 0,
            title: '审核通过',
          },
          {
            value: 1,
            title: '审核失败',
          },
        ],
      }
    },
  },
  mounted() {
    if (!this.$route.query.companyId) {
      this.$router.go(-1)
    }
    this.doQuery(this.$route.query.companyId)
  },
  methods: {
    ocrIdentify(url, type) {
      const theName = type === 'business' ? '营业执照' : type === 'idCard' ? '身份证人像面' : '身份证国徽面'
      if (!url) {
        return this.$message.error(`请上传${theName}`)
      }
      if (type === 'business') {
        this.businessLoading = true
        this.$axios
          .post('/auxiliary/admin/ocr/businessLicense', {
            url,
          })
          .then(res => {
            this.businessLoading = false
            if (res.success) {
              this.form.businessRegno = res.data.creditCode || res.data.certSN
              this.form.merchantName = res.data.companyName
              this.form.businessLicenseAddress = res.data.addressDetail
              this.form.businessLicenseHandleDate = res.data.establishDate
              this.form.businessLicenseCancelDate = res.data.vaildPeriod
              this.form.businessLicenseProvince = res.data.province
              this.form.businessLicenseCity = res.data.city
              this.form.businessLicenseRegion = res.data.district
              if (this.form.businessLicenseRegion) {
                this.getRegionInfo(this.form.businessLicenseRegion, 'businessLicenseAreaCode')
              }
            }
          })
          .catch(err => {
            console.log(err)
            this.businessLoading = false
          })
      } else if (type === 'idCard') {
        this.idCardLoading = true
        this.$axios
          .post('/auxiliary/admin/ocr/idcard/person', {
            url,
          })
          .then(res => {
            if (res.success) {
              this.idCardLoading = false
              this.form.legalIdCardName = res.data.name
              this.form.legalIdCardNumber = res.data.number
            }
            this.idCardLoading = false
          })
          .catch(error => {
            console.log(error)
            this.idCardLoading = false
          })
      } else if (type === 'idCardB') {
        this.idCardBLoading = true
        this.$axios
          .post('/auxiliary/admin/ocr/idcard/national', {
            url,
          })
          .then(res => {
            if (res.success) {
              this.idCardBLoading = false
              this.form.legalIdCardBeginDate = res.data.startDate
              if (res.data.permanent) {
                this.form.legalIdCardExpireDateChecked = true
                this.form.legalIdCardExpireDate = '9999-12-31'
              } else {
                this.form.legalIdCardExpireDate = res.data.endDate
              }
            }
            this.idCardBLoading = false
          })
          .catch(error => {
            console.log(error)
            this.idCardBLoading = false
          })
      }
    },
    doSave(type) {
      if (!this.form.businessRegno && this.form.companyType == 'COMPANY') {
        return this.$message.error('请填写营业执照编号')
      }
      this.$axios
        .put(
          `/user/admin/agent/status?companyId=${this.$route.query.companyId}&status=${type ? 0 : 2}&businessRegno=${
            this.form.businessRegno
          }`
        )
        .then(res => {
          if (res.success) {
            this.$router.go(-1)
          }
        })
    },
    doQuery(companyId) {
      this.$axios.get(`/user/admin/agent/${companyId}`).then(res => {
        if (res.success && res.data) {
          this.form = res.data
        }
      })
    },
    onChange() {},
  },
}
</script>
<style lang="less" scoped></style>
